module.exports = __webpack_public_path__ + "img/3.e0c642f9.jpg";